import { Link } from "react-router-dom";
import type { CuratedContentItem } from "@/types/content";
import { SHOW_INFO, CATEGORY_PILL_COLORS } from "@/data/curatedContent";
import { Badge } from "@/components/ui/badge";

interface ArticleRightRailProps {
  currentId: string;
  allItems: CuratedContentItem[];
}

export function ArticleRightRail({ currentId, allItems }: ArticleRightRailProps) {
  // Pick 5 diverse items (different shows preferred)
  const others = allItems.filter((i) => i.id !== currentId);
  const picked: CuratedContentItem[] = [];
  const usedShows = new Set<string>();

  // First pass: one per show
  for (const item of others) {
    if (picked.length >= 5) break;
    if (!usedShows.has(item.show)) {
      picked.push(item);
      usedShows.add(item.show);
    }
  }
  // Fill remaining
  for (const item of others) {
    if (picked.length >= 5) break;
    if (!picked.includes(item)) picked.push(item);
  }

  return (
    <div className="hidden lg:block" style={{ width: 300, flexShrink: 0 }}>
      <div className="sticky top-8">
        <h3
          className="text-xs font-bold uppercase tracking-widest text-muted-foreground"
          style={{ marginBottom: 20, letterSpacing: "0.1em" }}
        >
          More to Read
        </h3>
        <div className="space-y-1">
          {picked.map((item) => {
            const show = SHOW_INFO[item.show];
            const pill = CATEGORY_PILL_COLORS[item.category];
            return (
              <Link
                key={item.id}
                to={`/ai-ideas/${item.id}`}
                className="block rounded-lg p-3 -mx-3 hover:bg-muted/40 transition-colors"
              >
                <div className="flex items-center gap-2 mb-1.5">
                  {show && (
                    <img
                      src={show.logo}
                      alt={item.show}
                      className="h-5 w-5 rounded-full object-cover"
                    />
                  )}
                  <span className="text-xs font-medium text-muted-foreground">
                    {item.show}
                  </span>
                </div>
                <p className="text-sm font-semibold text-foreground leading-snug line-clamp-2">
                  {item.title}
                </p>
                {pill && (
                  <Badge
                    variant="secondary"
                    className={`text-[10px] mt-2 ${pill.bg} ${pill.text} ${pill.border}`}
                  >
                    {item.category}
                  </Badge>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
